import { CustomImgBox, CustomStack } from '@components/Styles/CommonStyle';

import React from 'react';
import { Typography } from '@mui/material';
import logoBrick from '@assets/images/logo/logo_brick.svg';
import { theme } from '@components/Styles/theme';

const Header = () => {
  return (
    <CustomStack>
      <CustomImgBox src={logoBrick} alt="브릭 로고" />
      <Typography sx={theme.typography.h5}>사업 관리 시스템</Typography>
    </CustomStack>
  );
};

export default Header;
